/**
 * Дизайн-токены приложения, оформленные как Tailwind-классы.
 * Один источник правды — все формы, кнопки, карточки используют эти константы.
 */

// ===== Inputs =====
export const inputBase =
  'block w-full rounded-md border border-border bg-bg text-text placeholder:text-text-subtle ' +
  'transition-colors duration-150 ease-out ' +
  'hover:border-border-strong ' +
  'focus:border-accent focus:outline-none focus:shadow-focus ' +
  'disabled:bg-bg3 disabled:text-text-subtle disabled:cursor-not-allowed';

export const inputCls = `${inputBase} h-9 px-3 text-sm`;
export const selectCls = inputCls;
export const textareaCls = `${inputBase} px-3 py-2 text-sm resize-none`;

// ===== Field label =====
export const fieldLabelCls = 'mb-1.5 block text-xs font-medium uppercase tracking-wide text-text2';

// ===== Buttons =====
const btnBase =
  'inline-flex items-center justify-center gap-2 rounded-md font-semibold ' +
  'transition-colors duration-150 ease-out select-none ' +
  'focus-visible:outline-2 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-accent ' +
  'disabled:opacity-50 disabled:cursor-not-allowed';

const sizeMd = 'h-9 px-3.5 text-sm';
const sizeSm = 'h-7 px-2.5 text-xs';

export const btnPrimary = `${btnBase} ${sizeMd} bg-accent text-white hover:bg-accent2 active:bg-accent2`;
export const btnPrimarySm = `${btnBase} ${sizeSm} bg-accent text-white hover:bg-accent2 active:bg-accent2`;

export const btnSecondary = `${btnBase} ${sizeMd} bg-bg text-text border border-border hover:bg-bg2 hover:border-border-strong`;
export const btnSecondarySm = `${btnBase} ${sizeSm} bg-bg text-text border border-border hover:bg-bg2 hover:border-border-strong`;

export const btnGhost = `${btnBase} ${sizeMd} bg-transparent text-text2 hover:bg-bg2 hover:text-text`;
export const btnGhostSm = `${btnBase} ${sizeSm} bg-transparent text-text2 hover:bg-bg2 hover:text-text`;

export const btnSuccess = `${btnBase} ${sizeMd} bg-success text-white hover:opacity-90`;
export const btnSuccessSm = `${btnBase} ${sizeSm} bg-success text-white hover:opacity-90`;

export const btnDanger = `${btnBase} ${sizeMd} bg-bg text-danger border border-[var(--red-border)] hover:bg-danger hover:text-white hover:border-danger`;
export const btnDangerSm = `${btnBase} ${sizeSm} bg-bg text-danger border border-[var(--red-border)] hover:bg-danger hover:text-white hover:border-danger`;

// ===== Cards =====
export const cardL1 = 'rounded-lg border border-border bg-bg2 p-5'; // карточки на странице (KPI, balances, user-form)
export const cardL2 = 'rounded-lg border border-border bg-bg3 p-4'; // внутри модалки/fieldset (preview, section)
export const cardInteractive = 'rounded-lg border border-border bg-bg2 p-5 transition-shadow duration-150 hover:shadow-xs hover:border-border-strong';

// ===== Page header =====
export const pageContainer = 'p-3 sm:p-6';
export const pageHeader = 'mb-4 flex flex-wrap items-start justify-between gap-3 sm:mb-6';
export const pageTitle = 'text-xl font-bold tracking-tight text-text sm:text-2xl';
export const pageSubtitle = 'mt-1 text-sm text-text2';

// ===== Section heading (внутри страницы / модалки) =====
export const sectionTitle = 'text-lg font-semibold text-text';
export const subSectionTitle = 'text-xs font-semibold uppercase tracking-wide text-text2';

// ===== Filter / pill button (для фильтров на OrdersPage) =====
const filterBase = `${btnBase} h-9 px-3 text-sm`;
export const filterIdle = `${filterBase} bg-bg text-text2 border border-border hover:bg-bg2 hover:text-text`;
export const filterActive = `${filterBase} bg-accent text-white hover:bg-accent2`;

// ===== Tables =====
export const tableCls = 'w-full text-sm';
export const tableWrapper = 'overflow-x-auto rounded-lg border border-border bg-bg2';
export const tableHead = 'border-b border-border bg-bg3 text-text2';
export const tableHeadCell = 'px-3 py-2.5 text-left text-[11px] font-medium uppercase tracking-wide';
export const tableHeadCellRight = `${tableHeadCell} text-right`;
export const tableCell = 'px-3 py-2.5';
export const tableCellNum = 'px-3 py-2.5 text-right font-mono tabular-nums';
export const tableRow = 'border-b border-border-subtle last:border-b-0';
